enum ProgramState {
  Stopped,
  Running,
  Paused,
  Finished
}

export default ProgramState
